export const WIDGET_ACTION = {
  createBlankProject: 'create_blank_project',
  createRecentProject: 'create_recent_project',
  createLocalizationProject: 'create_localization_project',
  createBlogProject: 'create_blog_project',
  improveContent: 'improve_content',
  openTemplateGallery: 'open_template_gallery',
} as const;
export type WidgetAction = (typeof WIDGET_ACTION)[keyof typeof WIDGET_ACTION];

export const QUICK_NAVIGATION_EVENT = {
  newBlankProject: 'new_blank_project',
  newLocalizationProject: 'new_localization_project',
  newBlogProject: 'new_blog_project',
  improveExistingContent: 'improve_existing_content',
  templateGallery: 'template_gallery',
} as const;
export type QuickNavigationEvent =
  (typeof QUICK_NAVIGATION_EVENT)[keyof typeof QUICK_NAVIGATION_EVENT];
